import React from 'react';
import { Table } from 'antd';
import * as Styled from '../styled';
import type { Details } from '../hooks';

interface Props {
  features?: Details['features'];
}

const columns = [
  {
    title: 'Key Features',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Status',
    dataIndex: 'value',
    key: 'value',
    render: (value) => {
      if (typeof value === 'boolean') {
        return value ? '✓' : '✗';
      }
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      return String(value);
    },
  },
];

export const FeatureSummary = (props: Props) => {
  const { features } = props;

  return (
    <Styled.SectionWrapper>
      <Styled.SectionTitle>Feature Summary</Styled.SectionTitle>
      <Table dataSource={features} columns={columns} pagination={false} />
    </Styled.SectionWrapper>
  );
};
